import React from "react";
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  size?: "lg" | "sm";
};
export function CtaButton({
  children,
  href,
  onClick,
  className = "",
  size = "lg"
}: CtaButtonProps) {
  const cls = `cta ${size === "sm" ? "cta-small" : ""} ${className}`;
  return href ? <a href={href} onClick={onClick} className={cls} data-id="element-27" data-mp="cjr8pyqxdxrq">{children}</a> : <button type="button" onClick={onClick} className={cls} data-id="element-28" data-mp="qkafz3nkgzsu">{children}</button>;
}